export default __webpack_public_path__ + "static/media/t13.af71ef99.jpg";